import { httpCreate } from './http';
import { createNamespacedHelpers } from 'vuex';

const http = httpCreate('/srv/activityImpower');

export const activityImpower = {
	// pageNum, pageSize,  page,
	getActivityPower(id, params) {
		return http.get(`/${id}`, { params });
	},
	// 获取用户关联的直播间列表
	// GET /srv/activityImpower/activity/:userId?pageNum&pageSize&keyWord
	getUserActivity(userId, params) {
		return http.get(`/activity/${userId}`, { params });
	},
	// 取消用户与直播间关联
	// DELETE /srv/activityImpower/activity/:userId/:activityId
	deleteUserActivity(userId, activityId) {
		return http.delete(`/activity/${userId}/${activityId}`);
	},
	addPower(data) {
		const params = { photoLive: 0 };
		return http.post(`/${data.activityId}/photo`, data, { params });
	},
	addUser(activityId, userId, params) {
		return http.post(`/${activityId}/addUser/${userId}`, {}, { params });
	},

	isOnSet(id, status) {
		const params = { status };
		return http.post(`/status/${id}`, {}, { params });
	},
	batchDel(data) {
		return http.post('/batchDel', data);
	},
	getActivityPowerCode(id, isRefresh) {
		return http.get(`/${id}/getImpowerCode`, { params: { isRefresh } });
	},
	delActivityPower(id) {
		return http.delete(`/${id}`);
	},
	//退出
	signout(activityId) {
		return http.post(`/${activityId}/cancelImpower`);
	},
	//获取邀请链接
	getImpowerUrl(activityId, params) {
		return http.get(`/${activityId}/getImpowerUrl`, { params });
	},
	//设置为发布员
	toPulish(activityId, params) {
		return http.put(`/${activityId}/toPulish`, {}, { params });
	},
	//设置为管理员
	toAdmin(activityId, params) {
		return http.put(`/${activityId}/toAdmin`, {}, { params });
	},
	// 批量添加权限成员，type: 2-管理员 3-评论管理员 5-核销督导员
	addImpowerBatch(activityId, type, ids) {
		// ids 为数组
		return http.post(`/${activityId}/addImpowerBatch/${type}`, ids);
	},
	//修改链接状态
	changeUrlStatus(activityId, params) {
		return http.post(`/${activityId}/changeUrlStatus`, {}, { params });
	},
	// //团队管理接口
	// getPersonnelList(){
	// 	return http.get(`/${id}`, { params });
	// }
};
